import React from "react";
import parse from "html-react-parser";
import cx from "classnames";
import styles from "./styles.module.sass";

interface MiniAddressProps {
  title?: string;
  address?: string;
  tel?: string;
  email?: string;
  hours?: string;
  fb?: string;
  ig?: string;
  ta?: string;
  wa?: string;
}

const MiniAddress: React.FC<MiniAddressProps> = ({
  title = "",
  address = "",
  tel = "",
  email = "",
  hours = "",
  fb = "",
  ig = "",
  ta = "",
  wa = "",
}) => (
  <div className={styles.block} style={{ maxWidth: 725 }}>
    {title && <h3 className={styles.title}>{title}</h3>}
    <div
      className={cx(styles.address, {
        [styles.width33]: Boolean(title),
      })}
    >
      <span>A:&nbsp;</span>
      <div>{parse(address)}</div>
    </div>
    <div
      className={cx(styles.contact, {
        [styles.width33]: Boolean(title),
      })}
    >
      H:&nbsp;{hours}
      {tel && (
        <>
          <br />
          T:&nbsp;{tel}
        </>
      )}
      {wa && (
        <>
          <br />
          W:&nbsp;{wa}
        </>
      )}
      <br />
      E:&nbsp;<a href={`mailto:${email}`}>{email}</a>
      <br />
      S:&nbsp;
      <a href={fb} target="_blank" rel="noopener noreferrer">
        facebook
      </a>
      {ig && (
        <>
          &nbsp;|&nbsp;
          <a href={ig} target="_blank" rel="noopener noreferrer">
            instagram
          </a>
        </>
      )}
      {ta && (
        <>
          &nbsp;|&nbsp;
          <a href={ta} target="_blank" rel="noopener noreferrer">
            tripadvisor
          </a>
        </>
      )}
    </div>
  </div>
);

export default MiniAddress;
